import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import SaveIcon from '@material-ui/icons/GetApp';
import classNames from 'classnames';
import {settings} from '../config/config';

const styles = theme => ({
  icon: {
    marginRight: theme.spacing.unit * 2
  }
});

class resultTable extends Component {
  render() {
    const {classes} = this.props;
    if (this.props.results.data.length === 0) {
      return (null);
    }
    return (<div className="scroll">
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>Download</TableCell>
            <TableCell>ファイル名</TableCell>
            <TableCell>ユーザー数</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{
            this.props.results.data.map(row => (<TableRow key={row.fileName}>
              <TableCell align="right">
                <a href={settings.download + row.fileName}>
                  <Button variant="contained" size="large" color="primary" className={classes.button}>
                    <SaveIcon className={classNames(classes.leftIcon, classes.iconSmall)} style={{
                        marginRight: "5px"
                      }}/>
                  </Button>
                </a>
              </TableCell>
              <TableCell align="right">{row.fileName}</TableCell>
              <TableCell align="right">{row.userCount}</TableCell>
            </TableRow>))
          }</TableBody>
      </Table>
    </div>)
  }
}

resultTable.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(resultTable);
